import React from 'react';
import Text from '../Text/Text';
import './LevelViewer.less';
import IconLevel from '../Icons/IconLevel';

export type LevelViewerProps = {
  level: string;
};

const LevelViewer: React.FC<LevelViewerProps> = ({ level }) => {
  const classNames = ['t-levelWrapper'];

  if (!level) {
    return null;
  }
  return (
    <div className={classNames.join(' ')}>
      <Text level={4} rows={1}>
        {level}
      </Text>
      <IconLevel size="sm" />
    </div>
  );
};

export default LevelViewer;
